import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=6a4e831f&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a4e831f')) {
      api.createRecord('6a4e831f', component.options)
    } else {
      api.reload('6a4e831f', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=6a4e831f&", function () {
      api.rerender('6a4e831f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/liff_access/Index.vue"
export default component.exports